import { m } from 'framer-motion';
import { styled, useTheme } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid, Typography } from '@mui/material';
import { PropTypes } from 'prop-types';
//  import { varFade } from '../../animate';
import MotionViewport from '../../animate/MotionViewport';
import Iconify from '../../Iconify';
import DetailsTooltips from '../Tooltip/DetailsTooltips';
// import ThematicSection from './ThematicSection';

AboutWithDate.propTypes = {
  info: PropTypes.object,
  text: PropTypes.any,
  subtext: PropTypes.string,
  heartAction: PropTypes.func,
  isFavorite: PropTypes.bool,
  printInstance: PropTypes.object,
  // printRef: PropTypes.object,
  title: PropTypes.string,
  // thematic: PropTypes.array
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(3, 0, 0, 0),
  backgroundColor: theme.palette.background.paper,
}));

const InfoText = styled('span')(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  fontWeight: 'bold',
  padding: theme.spacing(0, 1),
  top: '-3px',
}));

/*  const Icons = styled(Iconify)(({ theme }) => ({
    margin: theme.spacing(2, 1),
    cursor: "pointer",
    transition: "0.3s",
    "&:hover": {
        color: theme.palette.text.secondary
    }
}));    */

export default function AboutWithDate({
  info,
  text,
  subtext,
  heartAction,
  isFavorite,
  printInstance,
  /* printRef, */ title,
}) {
  const size = 20;
  const theme = useTheme();
  return (
    <RootStyle className="printable">
      <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
        <m.div /*   variants={varFade().inUp}   */>
          {info && (
            <Grid container sx={{ padding: '16px 8px' }}>
              <Grid item xs={12} sm={4} className="text-center">
                <Iconify icon={'fluent-emoji-high-contrast:spiral-calendar'} width={size} height={size} />
                <InfoText>{info.date}</InfoText>
              </Grid>
              <Grid item xs={12} sm={4} className="text-center">
                <Iconify icon={'charm:person'} width={size} height={size} />
                <InfoText>{info.author}</InfoText>
              </Grid>
              <Grid item xs={12} sm={4} className="text-center">
                <Iconify icon={'ant-design:clock-circle-outlined'} width={size} height={size} />
                <InfoText>{info.time}</InfoText>
              </Grid>
            </Grid>
          )}
          {/* <ThematicSection items={thematic} /> */}

          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="span"
                sx={{
                  fontSize: { xs: '1.1875rem', sm: '1.25rem' },
                  fontWeight: 'bold',
                  '& * > a ': {
                    color: `${theme.palette.mode === 'light' ? theme.palette.grey[900] : 'link.yellowLink'}`,
                  },
                }}
              >
                {text}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className="text-center" sx={{ padding: '8px 0px 4px 0px' }}>
            <Grid item xs={12} className="text-center noprintable">
              <DetailsTooltips
                printInstance={printInstance}
                // printRef={printRef}
                title={title}
                favorite={isFavorite}
                heartAction={heartAction}
                size={size * 2}
                heartShow
              />
            </Grid>
          </Grid>
          {subtext && (
            <Container
              component={MotionViewport}
              sx={{ position: 'relative', height: '100%', padding: { lg: '0 !important' } }}
            >
              <Grid container className="printable">
                <Grid item xs={12} className="text-left" sx={{ padding: '8px 0px' }}>
                  <Typography variant="body1">{subtext}</Typography>
                </Grid>
              </Grid>
            </Container>
          )}
        </m.div>
      </Container>
    </RootStyle>
  );
}
